// Password validation rules matching login form requirements
export const passwordRules = {
  minLength: /.{8,}/,
  hasUpperCase: /[A-Z]/,
  hasNumber: /[0-9]/,
  hasSymbol: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/,
};

type TranslationFunction = (key: string) => string;

/**
 * Validates password against security requirements:
 * - Minimum 8 characters
 * - At least 1 uppercase letter
 * - At least 1 number
 * - At least 1 symbol (!@#$%^&*()_+-=[]{};':"\\|,.<>/?)
 */
export const createPasswordValidator = (t: TranslationFunction) => {
  return (_: unknown, value: string) => {
    if (!value) {
      return Promise.reject(t('validation.passwordRequired'));
    }

    const errors: string[] = [];

    if (!passwordRules.minLength.test(value)) {
      errors.push(t('validation.minLength'));
    }
    if (!passwordRules.hasUpperCase.test(value)) {
      errors.push(t('validation.hasUpperCase'));
    }
    if (!passwordRules.hasNumber.test(value)) {
      errors.push(t('validation.hasNumber'));
    }
    if (!passwordRules.hasSymbol.test(value)) {
      errors.push(t('validation.hasSymbol'));
    }

    if (errors.length > 0) {
      return Promise.reject(`${t('validation.passwordRules')} ${errors.join(', ')}`);
    }

    return Promise.resolve();
  };
};
